import { type Listing } from '@/features/listing/types/listing-types';
import { getUserBearerCookie } from '@/features/user/cookies/cookie-user-bearer';
import sendHttpError from '@/libs/logger/requests/send-http-error';

export default async function deleteListingBookmark(
  listingId: Listing['id'],
  listingTypeId: number,
): Promise<void> {
  const headers: HeadersInit = {};

  const bearerToken = getUserBearerCookie();

  if (bearerToken) {
    headers.Authorization = `Bearer ${bearerToken}`;
  }

  const queryParams = new URLSearchParams({
    'model.bookmark_type': 'Bookmarked',
    'model.listing_id': String(listingId),
    'model.service_type': String(listingTypeId),
  }).toString();

  const url = `${process.env.NEXT_PUBLIC_API_URL}/v1/bookmarks?${queryParams}`;

  const deleteListingBookmarkResponse = await fetch(url, {
    cache: 'no-store',
    headers,
    method: 'DELETE',
  });

  if (!deleteListingBookmarkResponse.ok) {
    sendHttpError({
      baseName: 'Delete listing bookmark',
      functionName: 'deleteListingBookmark',
      method: 'DELETE',
      requestHeaders: headers,
      statusCode: deleteListingBookmarkResponse.status,
      url,
    });

    throw new Error('Failed to fetch data');
  }
}
